module.exports = __webpack_public_path__ + "static/img/ybgc.1391353b.png";